import React, { Component, Fragment } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { TrackedTextArea, DirtyWrapper } from 'Components';
import moment from 'moment';

import {
  noteRowInfoUpdate,
  updateNotesComponentState,
  getNotesInfo,
  saveNotesInfo,
  deleteNotesInfo,
} from 'Common/Components/StudentNoteModal/state/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { STUDENT_NOTES_SERVICE_USERNAME } from 'Common/Constants/index';

class StudentNotesContainer extends Component {
  state = {
    showDeleteConfirm: false,
    pageNumber: 0,
    modifedPageNumber: 0,
    changeNotes: true,
  };

  componentDidMount() {
    const { getNotesInfo, studentData, isApplicationNotes } = this.props;

    getNotesInfo(studentData, isApplicationNotes);
  }

  componentWillUnmount() {
    this.props.noteRowInfoUpdate({ isEmpty: true });
    this.props.updateNotesComponentState({ selected: -1 });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.changePage) {
      this.setState({ pageNumber: this.state.modifedPageNumber });
    }
  }

  columns = [
    {
      Header: 'Modified Date',
      accessor: 'formattedDate',
      filterable: false,
      resizable: false,
      sortMethod: (a, b) => {
        return moment(a) > moment(b) ? 1 : -1;
      },
    },
    this.props.isApplicationNotes
      ? {
          Header: 'Description',
          accessor: 'Description',
          filterable: false,
          resizable: false,
        }
      : {
          Header: 'User Name',
          accessor: 'UserName',
          filterable: false,
          resizable: false,
        },
  ];

  saveNotes = () => {
    const {
      isDirty,
      saveNotesInfo,
      resetDirty,
      noteRowInfoUpdate,
      notesState,
      updateNotesComponentState,
      isApplicationNotes,
    } = this.props;
    if (isDirty) {
      saveNotesInfo(notesState.isNew, isApplicationNotes);
      resetDirty();
      noteRowInfoUpdate({ isEmpty: true });
      updateNotesComponentState({ selected: -1 });
    }
  };

  newNotes = (showNewDataDirtyConfirm) => {
    showNewDataDirtyConfirm([
      {
        selected: -1,
        isNew: true,
      },
      { isEmpty: true },
    ]);
  };

  rowDataAction =
    (showNewDataDirtyConfirm) => (state, rowInfo, column, instance) => {
      const { notesState } = this.props;
      return {
        onClick: (e) => {
          showNewDataDirtyConfirm([
            {
              selected: rowInfo && rowInfo.index,
              isNew: false,
            },
            rowInfo.original,
          ]);
        },
        className:
          rowInfo && rowInfo.index === notesState.selected
            ? 'selected no-hover'
            : 'no-hover',
        style: { cursor: rowInfo && rowInfo.original ? 'pointer' : '' },
      };
    };

  changeInput = (e, data) => {
    if (this.props.notesState && this.props.notesState.selected === -1) {
      this.props.updateNotesComponentState({ isNew: true });
    }
    this.props.noteRowInfoUpdate({
      Description: data.value,
      StudentIdSeed: this.props.studentData.IdSeed,
      HouseholdId: this.props.studentData.HouseholdId,
    });
  };

  pageChange = (showNewDataDirtyConfirm) => (pageIndex) => {
    !this.props.isDirty && this.setState({ pageNumber: pageIndex });
    this.props.isDirty &&
      showNewDataDirtyConfirm([{ selected: -1 }, { isEmpty: true }, pageIndex]);
    this.setState({ modifedPageNumber: pageIndex });
  };

  handleDialog(result) {
    if (result) {
      this.props.deleteNotesInfo(this.props.isApplicationNotes);
      this.props.noteRowInfoUpdate({ isEmpty: true });
      this.props.updateNotesComponentState({ selected: -1 });
    }
    this.setState({ showDeleteConfirm: false });
  }

  closeNotesModalYes = (onClose) => () => {
    this.props.resetDirty();
    onClose();
  };

  renderButton = (showNewDataDirtyConfirm) => {
    const { isDirty, notesState } = this.props;

    return (
      <SecurityPreferences scope={PrefEnum.ModifyNotes}>
        {(disabled) => {
          return (
            <React.Fragment>
              <Button
                onClick={() => this.setState({ showDeleteConfirm: true })}
                inverted
                color="orange"
                size="big"
                content="Delete"
                disabled={
                  notesState.selected === -1 ||
                  disabled ||
                  (this.props.noteRowInfo &&
                    this.props.noteRowInfo.UserName &&
                    this.props.noteRowInfo.UserName.toUpperCase() ===
                      STUDENT_NOTES_SERVICE_USERNAME) ||
                  this.props.noteRowInfo.ReadOnly === 'Y'
                }
              />
              <Button
                onClick={() => this.newNotes(showNewDataDirtyConfirm)}
                inverted
                color="orange"
                size="big"
                content="New"
                disabled={notesState.selected === -1 || disabled}
              />
              <Button
                onClick={this.saveNotes}
                inverted
                color="orange"
                size="big"
                content="Save"
                disabled={!isDirty || disabled}
              />
            </React.Fragment>
          );
        }}
      </SecurityPreferences>
    );
  };

  showNewNoteData = (obj) => {
    this.props.updateNotesComponentState(obj[0]);
    this.props.noteRowInfoUpdate(obj[1]);
    if (obj.length > 2) {
      this.setState({ pageNumber: obj[2] });
    }
    this.props.resetDirty();
  };

  closeModal(showDirtyConfirm, onClose) {
    if (this.props.isDirty) {
      return showDirtyConfirm;
    }
    return onClose;
  }

  getNames = () => {
    const { studentData } = this.props;
    let firstName = studentData.FirstName;
    let lastName = studentData.LastName;
    if (
      this.props.studentData.FirstName == null &&
      this.props.studentData.LastName == null
    ) {
      firstName = studentData.HouseholdFirstName;
      lastName = studentData.HouseholdLastName;
    }

    return { firstName, lastName };
  };

  render() {
    const { open, onClose, noteRowInfo, notesInfo, notesState, isReadOnly } =
      this.props;
    const { showDeleteConfirm } = this.state;
    const names = this.getNames();

    return (
      <DirtyWrapper
        closeModalYesCallback={this.closeNotesModalYes(onClose)}
        showNewDataYesCallback={this.showNewNoteData}
        changeStatus={(status) => this.setState({ changeNotes: status })}
        question={'Changes are not saved, do you want continue?'}
        isReadOnly={isReadOnly}
      >
        {(showDirtyConfirm, showDirtyLinkConfirm, showNewDataDirtyConfirm) => (
          <Fragment>
            <Modal
              open={open}
              onClose={this.closeModal(showDirtyConfirm, onClose)}
              closeIcon
              size={'small'}
              closeOnRootNodeClick={false}
            >
              <Header
                content={`Notes - ${names.firstName} ${names.lastName}`}
                icon={'sticky note'}
              />
              <Modal.Content className="p-t-0">
                <ReactTable
                  page={this.state.pageNumber}
                  minRows={5}
                  data={notesInfo}
                  defaultPageSize={5}
                  showPageSizeOptions={false}
                  columns={this.columns}
                  getTrProps={this.rowDataAction(showNewDataDirtyConfirm)}
                  onPageChange={this.pageChange(showNewDataDirtyConfirm)}
                  defaultSorted={[
                    {
                      id: 'formattedDate',
                      desc: true,
                    },
                  ]}
                />
                <SecurityPreferences scope={PrefEnum.ModifyNotes}>
                  {(disabled) => {
                    return (
                      <TrackedTextArea
                        rows={10}
                        label={'Description'}
                        style={{ width: '100%', resize: 'none' }}
                        initialValue={
                          notesState.isNew
                            ? ''
                            : noteRowInfo && noteRowInfo.Description
                        }
                        value={noteRowInfo && noteRowInfo.Description}
                        onChange={this.changeInput}
                        showFocus={true}
                        disabled={
                          disabled ||
                          this.props.noteRowInfo.ReadOnly === 'Y' ||
                          (noteRowInfo &&
                            noteRowInfo.UserName &&
                            noteRowInfo.UserName.toUpperCase() ===
                              STUDENT_NOTES_SERVICE_USERNAME)
                        }
                      />
                    );
                  }}
                </SecurityPreferences>
              </Modal.Content>
              <Modal.Actions>
                {this.renderButton(showNewDataDirtyConfirm)}
              </Modal.Actions>
            </Modal>
            <YesNoDialog
              showDialog={showDeleteConfirm}
              title="Confirm"
              question={`Are you sure you want to delete this note?`}
              yesCallback={() => {
                this.handleDialog(true);
              }}
              noCallback={() => {
                this.handleDialog(false);
              }}
            />
          </Fragment>
        )}
      </DirtyWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    noteRowInfo: state.StudentNotesState.noteRowInfo,
    notesInfo: state.StudentNotesState.studentNotesInfo,
    notesState: state.StudentNotesState.notesState,
    isDirty: getIsDirty()(state),
  };
};

export const StudentNotesModal = connect(mapStateToProps, {
  noteRowInfoUpdate,
  updateNotesComponentState,
  getNotesInfo,
  saveNotesInfo,
  deleteNotesInfo,
  resetDirty,
})(StudentNotesContainer);



// WEBPACK FOOTER //
// ./src/components/forms/StudentNotesModal.js